// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"838c727e","150":"838c727e"}[chunkId] + ".chunk.css";
};